import {
    Field,
    ProgressBar,
    ProgressBarProps,
  } from "@fluentui/react-components";
  import * as React from "react";
  
  interface PendingProgressProps extends Partial<ProgressBarProps> {
    validationMessage?: string;
  }
  
  const PendingProgress: React.FC<PendingProgressProps> = ({validationMessage, ...props}) => {
    return (
      <Field validationMessage={validationMessage} validationState="none">
        <ProgressBar {...props} />
      </Field>
    );
  };
  
  export default PendingProgress;
  